enum ListingUploadQueryTypesEnum {
    Personal = 'Personal',
    All = 'All',
  }

export default ListingUploadQueryTypesEnum;
